import React from "react";
import Tooltip from "ui/components/Tooltip/Tooltip";
import { TooltipProps } from "ui/components/Tooltip/types";

/**
 * Tanak wrapper oko Tooltip komponente koji standardizira "info popup" obrazac
 * korišten u svim dashboard karticama (VehicleCell stil — bg-slate-800, naslov,
 * label/value redovi, opcionalni separator i istaknuti red).
 *
 * Koristi se s helperima TooltipTitle / TooltipRow / TooltipDivider iz iste datoteke.
 */
interface DashboardTooltipProps {
  trigger: React.ReactNode;
  position?: TooltipProps["position"];
  children: React.ReactNode;
}

const DashboardTooltip: React.FC<DashboardTooltipProps> = ({
  trigger,
  position = "top-left",
  children,
}) => {
  return (
    <Tooltip position={position} trigger={trigger}>
      <div className="min-w-[220px]">{children}</div>
    </Tooltip>
  );
};

export default DashboardTooltip;

export const TooltipTitle: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <div className="text-xs uppercase text-slate-400 mb-2 font-semibold">{children}</div>
);

interface TooltipRowProps {
  label: React.ReactNode;
  value: React.ReactNode;
  emphasis?: "default" | "positive" | "negative" | "muted";
}

export const TooltipRow: React.FC<TooltipRowProps> = ({ label, value, emphasis = "default" }) => {
  const valueClass =
    emphasis === "positive"
      ? "font-bold text-green-400"
      : emphasis === "negative"
        ? "font-bold text-red-400"
        : emphasis === "muted"
          ? "text-slate-400"
          : "font-medium";
  return (
    <div className="flex justify-between text-sm mb-1 gap-4">
      <span className="text-slate-300">{label}</span>
      <span className={valueClass}>{value}</span>
    </div>
  );
};

export const TooltipDivider: React.FC = () => (
  <div className="border-t border-slate-600 my-2"></div>
);
